define('SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderDropdownOpen',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {

        function SolutionFinderDropdownOpenEvent() {
            EventBase.call(this); // inherit eventBase
            this.name = "button_click"; // overwrite name
        }

        SolutionFinderDropdownOpenEvent.prototype = Object.create(EventBase.prototype);

        SolutionFinderDropdownOpenEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(dropdownOpened) {
            const eventType = "nova_{DROPDOWN}_dropdown_open";
            var text = eventType.replace("{DROPDOWN}", dropdownOpened);

            var eventData = {
                'event_name': this.getName(),
                'element_text' : text
            }
            return eventData;
        }
        return new SolutionFinderDropdownOpenEvent();
    });
